import { OrderDetail } from "@omni/types/api/cart/bff/orderDetail.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import * as OrderUtils from "@omni/utils/order.utils";
import { cn } from "@omni/utils/styles";

import { TooltipType } from "@/components/General/Tooltip/tooltip.types";
import { DeviceFingerPrintingProvider } from "@/components/Product/Reviews/context/deviceFingerPrinting.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { BreakpointProvider } from "@/utils/breakpoints/breakpoints.provider";

import PriceSummary from "../shared/PriceSummary/priceSummary.component";
import { ProductCollectionBlock } from "../shared/ProductCollectionBlock/productCollectionBlock.container";
import { DeliveryPromiseComponent } from "./DeliveryPromise/deliveryPromise.component";
import Details from "./Details/details.component";

type Props = {
    orderDetails: OrderDetail;
    additionalServiceTooltip?: TooltipType;
};

const OrderDetailComponent = ({
    orderDetails,
    additionalServiceTooltip
}: Props) => {
    const { t } = useGranite();

    const deliveryProducts = orderDetails.items.filter(
        (i) =>
            i.deliveryType === DeliveryType.HomeDelivery &&
            !OrderUtils.productIsAdditionalService(orderDetails.items, i.id)
    );
    const collectProducts = orderDetails.items.filter(
        (i) =>
            i.deliveryType === DeliveryType.ClickAndCollect &&
            !OrderUtils.productIsAdditionalService(orderDetails.items, i.id)
    );

    return (
        <BreakpointProvider>
            <DeviceFingerPrintingProvider>
                <h5 className={cn("font-weight-bold")}>
                    {t("orderOverview.title.orderId")}
                    {orderDetails.orderId}
                </h5>
                <ProductCollectionBlock
                    deliveryProducts={deliveryProducts}
                    collectProducts={collectProducts}
                    additionalServiceTooltip={additionalServiceTooltip}
                    productTitleLink={true}
                    reviewsAllowed={true}
                    DeliveryPromiseComponent={DeliveryPromiseComponent}
                />
                <PriceSummary orderDetails={orderDetails} />
                <Details orderDetails={orderDetails} />
            </DeviceFingerPrintingProvider>
        </BreakpointProvider>
    );
};

export { OrderDetailComponent };
